import React from 'react';
import { assets } from '../data/mock';
import PriceUrgency from './CountdownTimer';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';

const LastChanceSection = () => {
  const { startCheckout } = useCheckout();
  const t = useT();
  return (
    <section className="relative mt-20 px-[30px] lg:px-0">
      <div className="mx-auto max-w-[1140px]">
        <div className="my-[88px] relative overflow-hidden" style={{ backgroundColor: '#1B2A4A' }}>
          <img alt="Background" loading="lazy" width="2280" height="464" className="object-cover absolute top-0 left-0 z-0 w-full h-full" src={assets.lastChanceBg} />
          <div className="relative z-10 py-8 px-4" style={{ color: 'white' }}>
            <h2 className="text-center text-[32px] lg:text-[48px] font-bold pt-4" style={{ fontFamily: '"Space Grotesk", sans-serif', color: 'white' }}>
              {t.lastChance.title}
            </h2>
            <div className="mt-5 flex justify-center"><PriceUrgency size="small" /></div>
            <div className="w-full text-center mt-6 flex flex-col gap-4 items-center">
              <div onClick={() => startCheckout('last_chance_cta')} className="cursor-pointer">
                <button className="cta-urgent lg:w-min lg:min-w-[266px] text-[#1B2A4A] text-xl border-2 p-[1px] group bg-[#F2F5FB] border-[#1B2A4A] hover:text-white duration-300 transition-all font-bold">
                  <div className="bg-white py-3.5 px-9 group-hover:bg-[#1B2A4A] duration-300 transition-all m-[1px]">{t.lastChance.cta}</div>
                </button>
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 mt-4">
              <span className="text-[14px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif', color: 'white' }}>{t.lastChance.subtitle}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LastChanceSection;
